import 'polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import '../node_modules/nouislider/distribute/nouislider.min.css'
import './App.css'
import * as serviceWorker from './registerServiceWorker'

const store = configureStore()
const rootEl = document.getElementById('root')

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  rootEl
)
serviceWorker.register()



// WEBPACK FOOTER //
// ./src/index.js